var path = 'public/app/plugins/datasource/cloudwatch/partials/annotations.editor.html';
var html = "<cloudwatch-annotation-query-editor datasource=ctrl.datasource on-change=ctrl.onChange query=ctrl.annotation></cloudwatch-annotation-query-editor>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;